import { render, staticRenderFns } from "./dioDetails.vue?vue&type=template&id=6a1f2b50&scoped=true&"
import script from "./dioDetails.vue?vue&type=script&lang=js&"
export * from "./dioDetails.vue?vue&type=script&lang=js&"
import style0 from "./dioDetails.vue?vue&type=style&index=0&id=6a1f2b50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1f2b50",
  null
  
)

export default component.exports